import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';
import { memo } from 'react';

import theme from 'src/style-system/theme';
import SuperTasty from '@public/assets/svg/SuperTasty.svg';
import MoneySaving from '@public/assets/svg/MoneySaving.svg';
import realRecipes from '@public/assets/png/realRecipes.png';

import { MiddleSectionContent } from '../constant';

import { useStyles } from './useStyles';

const MiddleSection = () => {
  const classes = useStyles();

  const logoRender = (index: number) => {
    const classes = useStyles();

    if (index === 0) {
      return (
        <Box className={classes.MoneySavingLogo}>
          <MoneySaving />
        </Box>
      );
    } else if (index === 1) {
      return (
        <Box className={classes.superTastyLogo}>
          <SuperTasty />
        </Box>
      );
    } else if (index === 2) {
      return (
        <Box className={classes.realRecipesLogo}>
          <Image
            src={realRecipes}
            alt="Logo"
            objectFit="contain"
            layout="fill"
            priority={true}
          />
        </Box>
      );
    }
  };

  return (
    <Box className={classes.mainContainer}>
      <Container maxWidth="xl" disableGutters>
        <Box className={classes.contentContainer}>
          {MiddleSectionContent.map((content, index) => {
            return (
              <Box
                key={content.id}
                className={classes.content}
                sx={{
                  flexDirection: 'column',
                  [theme.breakpoints.up(750)]: {
                    flexDirection: content.id === '2' ? 'row-reverse' : 'row',
                  },
                }}
              >
                <Box sx={{ position: 'relative' }}>
                  {logoRender(index)}
                  <Box className={classes.imgWrapper}>
                    <Image
                      src={content.icon}
                      alt={content.alt}
                      objectFit="contain"
                      layout="fill"
                      priority={true}
                    />
                  </Box>
                </Box>
                <Box className={classes.titleContentWrapper}>
                  <Typography
                    variant="body1"
                    align="center"
                    color="garamMasala.main"
                    className={classes.id}
                  >
                    {content.id}
                  </Typography>
                  <Box className={classes.title}>
                    <Typography
                      variant="h3"
                      color="cinnamon.main"
                      sx={{
                        textAlign: 'center',
                        [theme.breakpoints.up(750)]: {
                          textAlign: 'justify',
                        },
                      }}
                    >
                      {content.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="garamMasala.main"
                      sx={{
                        textAlign: 'center',
                        [theme.breakpoints.up(750)]: {
                          textAlign: 'justify',
                        },
                      }}
                    >
                      {content.subtitle}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default memo(MiddleSection);
